import { Link } from 'react-router-dom'
import { HelpCircle, MessageSquare } from 'lucide-react'
import { motion } from 'framer-motion'
import Navbar from '../components/layout/Navbar'
import Footer from '../components/layout/Footer'
import FaqList from '../components/landing/FaqList'
import { usePageMeta } from '../hooks/usePageMeta'

function FaqsPage() {
  usePageMeta({
    title: 'Rithmo FAQs: Common Questions Answered',
    description: 'Frequently asked questions about Rithmo, the AI meeting host. How it works with Zoom, what it tracks, how to get started, and more.',
  })
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-primary-50/50 to-white" />
        <div className="absolute top-1/3 right-1/4 w-80 h-80 bg-accent-500/8 rounded-full blur-3xl" />
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary-500/8 rounded-full blur-3xl" />

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex justify-center mb-4">
              <span className="badge-primary text-sm px-4 py-1.5 flex items-center gap-2">
                <HelpCircle className="w-3.5 h-3.5" />
                Frequently Asked Questions
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 leading-tight">
              Got questions?{' '}
              <span className="gradient-text">We have answers.</span>
            </h1>
            <p className="text-lg text-gray-600 max-w-xl mx-auto">
              Everything you need to know about Rithmo, from getting started to advanced features.
            </p>
          </motion.div>
        </div>
      </section>

      {/* FAQ list */}
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <FaqList listClassName="" />
          </motion.div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 bg-gray-50 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-white via-primary-50/30 to-white" />
        <div className="relative max-w-xl mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="w-14 h-14 rounded-2xl bg-gradient-primary flex items-center justify-center shadow-glow-sm text-white mx-auto mb-5">
              <MessageSquare className="w-6 h-6" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Still have questions?</h2>
            <p className="text-gray-600 mb-8">Our team is happy to help with anything not covered here.</p>
            <Link to="/contact" className="btn-primary inline-flex">
              Contact Us
            </Link>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default FaqsPage
